import { useQuery } from '@tanstack/react-query';
import { getSegmentDefinitions, SegmentDefinitionSummary } from './segment-definitions-api';

const SEGMENT_DEFINITIONS_QUERY_KEY = ['segmentDefinitions'];

export function useSegmentDefinitions() {
  return useQuery<SegmentDefinitionSummary[], Error>({
    queryKey: SEGMENT_DEFINITIONS_QUERY_KEY,
    queryFn: getSegmentDefinitions,
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
  });
}
